import { Heart } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="w-full border-t border-slate-200/50 dark:border-slate-700/50 bg-white/50 dark:bg-slate-900/50 backdrop-blur-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between py-6 gap-4">
          {/* Copyright */}
          <p className="text-sm text-slate-500 dark:text-slate-400">
            © {currentYear} All Rights Reserved.
          </p>

          {/* Credits */}
          <p className="text-sm text-slate-500 dark:text-slate-400 flex items-center gap-1">
            Designed and Developed with{' '}
            <Heart className="w-4 h-4 text-light-baby-pink dark:text-dark-burnt-peach fill-current" />{' '}
            by{' '}
            <a
              href="https://www.linkedin.com/in/sankar4/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-slate-700 dark:text-slate-300 hover:text-light-icy-blue dark:hover:text-dark-muted-teal transition-colors"
            >
              Sankar Balasubramanian
            </a>{' '}
            and{' '}
            <a
              href="https://www.linkedin.com/in/aadya-bharti-b8b7471b6/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-slate-700 dark:text-slate-300 hover:text-light-icy-blue dark:hover:text-dark-muted-teal transition-colors"
            >
              Aadya Bharti
            </a>
          </p>

          {/* Links */}
          <div className="flex items-center gap-4">
            <a
              href="/docs/COMMANDS.md"
              className="text-sm text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300 transition-colors"
            >
              Commands
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
